var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 18.8222L14.781 13.6039C16.1365 11.946 16.803 9.83063 16.6425 7.69518C16.4821 5.55974 15.507 3.56766 13.919 2.13098C12.331 0.694309 10.2515 -0.0770391 8.1107 -0.0235126C5.96991 0.030014 3.93158 0.90432 2.41734 2.41856C0.903099 3.9328 0.0287933 5.97113 -0.0247333 8.11192C-0.0782598 10.2527 0.693089 12.3322 2.12976 13.9202C3.56644 15.5082 5.55852 16.4833 7.69396 16.6438C9.82941 16.8042 11.9448 16.1377 13.6027 14.7822L18.821 20.0006L19.9993 18.8222ZM8.33266 15.0006C7.01412 15.0006 5.72519 14.6096 4.62886 13.877C3.53253 13.1445 2.67805 12.1033 2.17347 10.8851C1.66888 9.66693 1.53686 8.32649 1.79409 7.03328C2.05133 5.74008 2.68627 4.55219 3.61862 3.61984C4.55097 2.68749 5.73885 2.05255 7.03206 1.79532C8.32527 1.53808 9.66571 1.6701 10.8839 2.17469C12.1021 2.67927 13.1433 3.53375 13.8758 4.63008C14.6083 5.72641 14.9993 7.01534 14.9993 8.33388C14.9973 10.1014 14.2943 11.7959 13.0445 13.0457C11.7947 14.2955 10.1002 14.9986 8.33266 15.0006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOutlinedIcon);
export default __webpack_public_path__ + "static/media/searchOutlinedIcon.b81945397bdebb96869263b2ae172cfd.svg";
export { ForwardRef as ReactComponent };